// src/pages/public/authPage.jsx
import React from "react";
import AuthForm from "../../components/specific/AuthForm";

export default function AuthPage() {
  return (
      <AuthForm />
  );
}